/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-alertes[_ngcontent-%COMP%]{position:relative;color:#fff;padding-top:5px;padding-right:5px}.btn-alertes[_ngcontent-%COMP%]   .badge-alertes[_ngcontent-%COMP%]{position:absolute;border-radius:30%;padding:0 2px;background:#000;top:0;right:0;font-size:10px}.btn-alertes[_ngcontent-%COMP%]:hover{cursor:pointer}"];
export { styles as styles };
